import { render, staticRenderFns } from "./Rotator3.vue?vue&type=template&id=64e9584c&scoped=true"
import script from "./Rotator3.vue?vue&type=script&lang=js"
export * from "./Rotator3.vue?vue&type=script&lang=js"
import style0 from "./Rotator3.vue?vue&type=style&index=0&id=64e9584c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e9584c",
  null
  
)

export default component.exports